// 首登与主动改密共用页面，首登免填当前密码。

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Field, Input, useSubmitLock } from "@bf/ui";
import { isApiClientError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export function ChangePasswordPage() {
  const { changePassword, user } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const forced = user?.mustChangePassword ?? false;
  const [password2, setPassword2] = useState("");
  const { pending: loading, run } = useSubmitLock();
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    await run(async () => {
      try {
        await changePassword(password, password2, forced ? undefined : currentPassword);
        navigate("/", { replace: true });
      } catch (err) {
        setError(isApiClientError(err) ? err.message : "改密失败，请稍后重试");
      }
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg)] p-4">
      <div className="w-full max-w-sm rounded-[var(--radius-lg)] border border-line bg-panel p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-ink">设置新密码</h1>
        <p className="mt-1.5 text-sm text-muted">
          {user?.mustChangePassword ? "首次登录必须修改初始密码后才能继续使用。" : "请输入新密码。"}
        </p>
        <form className="mt-6 space-y-3" onSubmit={(event) => void handleSubmit(event)}>
          {!forced && <Field label="当前密码" required>
            <Input type="password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password" autoFocus required maxLength={200} />
          </Field>}
          <Field label="新密码" required hint="至少 8 位">
            <Input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Field>
          <Field label="确认新密码" required>
            <Input
              type="password"
              autoComplete="new-password"
              value={password2}
              onChange={(event) => setPassword2(event.target.value)}
            />
          </Field>
          {error && <Alert tone="danger">{error}</Alert>}
          <Button type="submit" variant="primary" className="h-11 w-full text-base" loading={loading} disabled={password.length < 8 || password !== password2}>
            保存并继续
          </Button>
        </form>
      </div>
    </div>
  );
}
